import { useLocale } from '@solinkcorp/locale';
import { Button } from '@solinkcorp/solink-ui/components/Button';
import { Tooltip, TooltipContent, TooltipTrigger } from '@solinkcorp/solink-ui/components/Tooltip';
import { cn } from '@solinkcorp/solink-ui/lib/utils';
import { CalendarRange } from 'lucide-react';

// Icon used for collapsed day part sidebar. Shown only in edit mode.
export const DayPartSidebarTrigger = ({
  open,
  toggleSidebar,
}: {
  open: boolean;
  toggleSidebar: () => void;
}) => {
  const locale = useLocale();

  return (
    <div className={cn('mt-px h-full border border-border bg-background-surface shadow-sm')}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span className={cn('inline-flex', !open && 'mx-3 my-5')}>
            <Button
              variant="ghost"
              size="icon"
              onClick={toggleSidebar}
              className="hover:bg-interaction-neutral-background-hover hover:text-interaction-neutral-content-default"
            >
              <CalendarRange size={16} />
            </Button>
          </span>
        </TooltipTrigger>
        <TooltipContent
          side="left"
          className="bg-background-elevated text-text-primary shadow-sm [&_span_svg]:!bg-background-elevated [&_span_svg]:!fill-background-elevated"
        >
          <p>{locale.serviceDisplayMonitor.dayPartsTitle}</p>
        </TooltipContent>
      </Tooltip>
    </div>
  );
};
